import ApiService from '@/services/api.service'

const IPFcomoadjustmentsService = {
    getAll(parameter){
        const requestData = {
            method: 'get',
            url: "/ipfcomoadjustments/",
            params: {
              SearchCriteria: parameter.SearchCriteria,
              PageSize: parameter.PageSize,
              PageNumber: parameter.PageNumber,
            }
          }
          return ApiService.customRequest(requestData);
    },


    Add(data){
        return ApiService.post(`/ipfcomoadjustments`, data);
    },
    Delete(Id){
        return ApiService.delete(`/ipfcomoadjustments/${Id}`);
    },
    Update(Id,data){
        return ApiService.put(`/ipfcomoadjustments/${Id}`,data);
    },
    Get(Id){
        return ApiService.get(`/ipfcomoadjustments/${Id}`);
    }
  }

  export default IPFcomoadjustmentsService;
